// =============================================================================
// FILE:
// src/modules/pms/task_material/pages/MaterialReservationPage.js
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";

import {
  PackageCheck,
  Search,
  RefreshCw
} from "lucide-react";

import {
  getMaterialReservationList,
  getProjects,
  getProjectPhases,
  getPhaseTasks,
  createReservation
} from "../services/materialReservationService";


// =============================================================================
// PAGE
// =============================================================================

export default function MaterialReservationPage() {

  // ===========================================================================
  // FILTERS
  // ===========================================================================
  const [projectId, setProjectId] =
    useState("");

  const [phaseId, setPhaseId] =
    useState("");

  const [taskId, setTaskId] =
    useState("");

  const [status, setStatus] =
    useState("ALL");

  const [searchText, setSearchText] =
    useState("");

  const [siteStoreName] =
    useState(
      "IPE-ORD-20260513-0003"
    );


  // ===========================================================================
  // KPI
  // ===========================================================================
  const [kpis, setKpis] =
    useState({

      plannedMaterials: 0,

      plannedQty: 0,

      reservedQty: 0,

      balanceQty: 0,

      pendingTasks: 0
    });


  // ===========================================================================
  // DATA
  // ===========================================================================
  const [rows, setRows] =
    useState([]);
  const [projects, setProjects] =
  useState([]);

  const [phases, setPhases] =
    useState([]);

  const [tasks, setTasks] =
    useState([]);
  const [drawerOpen, setDrawerOpen] =
  useState(false);

const [selectedRow, setSelectedRow] =
  useState(null);

const [reserveQty, setReserveQty] =
  useState("");

const [remarks, setRemarks] =
  useState("");

const [saving, setSaving] =
  useState(false);

const [drawerError, setDrawerError] =
  useState("");

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");
  
  
  const [summary, setSummary] =
  useState({

    project_name: "-",

    phase_name: "-",

    task_name: "-",

    status: "-"
  });  


  // ===========================================================================
  // LOAD DATA
  // ===========================================================================
  
  const loadTasks = async (
  selectedPhaseId
) => {

  try {

    if (!selectedPhaseId) {

      setTasks([]);

      return;
    }

    const response =
      await getPhaseTasks(
        selectedPhaseId
      );

    if (response.success) {

      setTasks(
        response.data || []
      );
    }

  } catch (err) {

    console.error(err);
  }
};

const openReserveDrawer = (
  row
) => {

  setSelectedRow(row);

  setReserveQty("");

  setRemarks("");

  setDrawerError("");

  setDrawerOpen(true);
};
const closeDrawer = () => {

  setDrawerOpen(false);

  setSelectedRow(null);

  setReserveQty("");

  setRemarks("");

  setDrawerError("");
};
const submitReservation =
  async () => {

    try {

      setDrawerError("");

      if (!reserveQty) {

        setDrawerError(
          "Reserve qty is required"
        );

        return;
      }

      const qty =
        parseFloat(reserveQty);

      if (qty <= 0) {

        setDrawerError(
          "Reserve qty must be greater than zero"
        );

        return;
      }

      if (
        qty >
        selectedRow.balance_qty
      ) {

        setDrawerError(
          "Reserve qty cannot exceed balance qty"
        );

        return;
      }

      setSaving(true);

      const response =
        await createReservation({

          task_material_plan_id:
            selectedRow.task_material_plan_id,

          reserve_qty: qty,

          remarks
        });

      if (response.success) {

        closeDrawer();

        loadReservationData();

      } else {

        setDrawerError(

          response.message ||
          "Reservation failed"
        );
      }

    } catch (err) {

      console.error(err);

      setDrawerError(
        "Failed to create reservation"
      );

    } finally {

      setSaving(false);
    }
};


  const loadPhases = async (
  selectedProjectId
) => {

  try {

    if (!selectedProjectId) {

      setPhases([]);

      return;
    }

    const response =
      await getProjectPhases(
        selectedProjectId
      );

    if (response.success) {

      setPhases(
        response.data || []
      );
    }

  } catch (err) {

    console.error(err);
  }
};
  const loadProjects = async () => {

  try {

    const response =
      await getProjects();

    if (response.success) {

      setProjects(
        response.data || []
      );
    }

  } catch (err) {

    console.error(err);
  }
};
  const loadReservationData = async () => {

    try {

      setLoading(true);

      setError("");

      const response =
        await getMaterialReservationList({

          project_id:
            projectId || undefined,

          phase_id:
            phaseId || undefined,

          task_id:
            taskId || undefined,

          status:
            status !== "ALL"
              ? status
              : undefined,

          search:
            searchText || undefined
        });

      if (response.success) {

        setKpis(
          response.data.kpis || {}
        );

        setSummary(
          response.data.summary || {}
        );
        setRows(
          response.data.rows || []
        );
      }

    } catch (err) {

      console.error(err);

      setError(
        "Failed to load reservation data"
      );

    } finally {

      setLoading(false);
    }
  };


  // ===========================================================================
  // INITIAL LOAD
  // ===========================================================================
  useEffect(() => {

  loadProjects();

}, []);
useEffect(() => {

  loadPhases(projectId);

  setPhaseId("");

  setTaskId("");

}, [projectId]);
useEffect(() => {

  loadTasks(phaseId);

  setTaskId("");

}, [phaseId]);

useEffect(() => {

  if (!projectId) {

    setRows([]);

    return;
  }

  loadReservationData();

}, [

  projectId,

  phaseId,

  taskId,

  status,

  searchText
]);

    //projectId,

    //phaseId,

    //taskId,

    //status,

    //searchText
  //]);


  // ===========================================================================
  // UI
  // ===========================================================================
  return (

    <div style={styles.page}>

      {/* ================================================================ */}
      {/* HEADER */}
      {/* ================================================================ */}
      <div style={styles.headerCard}>

        <div style={styles.headerLeft}>

          <div style={styles.headerIconWrap}>
            <PackageCheck size={24} />
          </div>

          <div>

            <div style={styles.headerTitle}>
              Material Reservation
            </div>

            <div style={styles.headerSubtitle}>
              Reserve planned materials against
              project tasks
            </div>

          </div>

        </div>


        <div style={styles.headerActions}>

          <button
            style={styles.refreshBtn}
            onClick={loadReservationData}
          >

            <RefreshCw size={16} />

            Refresh

          </button>

        </div>

      </div>


      {/* ================================================================ */}
      {/* KPI CARDS */}
      {/* ================================================================ */}
      <div style={styles.kpiGrid}>


        {/* Planned Materials */}
        <div
          style={{
            ...styles.kpiCard,
            borderTop: "4px solid #2563eb"
          }}
        >

          <div>

            <div style={styles.kpiLabel}>
              Planned Materials
            </div>

            <div style={styles.kpiValue}>
              {kpis.plannedMaterials}
            </div>

          </div>

          <div style={styles.kpiIcon}>
            📦
          </div>

        </div>


        {/* Planned Qty */}
        <div
          style={{
            ...styles.kpiCard,
            borderTop: "4px solid #16a34a"
          }}
        >

          <div>

            <div style={styles.kpiLabel}>
              Planned Qty
            </div>

            <div style={styles.kpiValue}>
              {kpis.plannedQty}
            </div>

          </div>

          <div style={styles.kpiIcon}>
            ✔
          </div>

        </div>


        {/* Reserved Qty */}
        <div
          style={{
            ...styles.kpiCard,
            borderTop: "4px solid #0891b2"
          }}
        >

          <div>

            <div style={styles.kpiLabel}>
              Reserved Qty
            </div>

            <div style={styles.kpiValue}>
              {kpis.reservedQty}
            </div>

          </div>

          <div style={styles.kpiIcon}>
            🏷
          </div>

        </div>


        {/* Balance Qty */}
        <div
          style={{
            ...styles.kpiCard,
            borderTop: "4px solid #ea580c"
          }}
        >

          <div>

            <div style={styles.kpiLabel}>
              Balance Qty
            </div>

            <div style={styles.kpiValue}>
              {kpis.balanceQty}
            </div>

          </div>

          <div style={styles.kpiIcon}>
            ⏳
          </div>

        </div>


        {/* Pending Tasks */}
        <div
          style={{
            ...styles.kpiCard,
            borderTop: "4px solid #dc2626"
          }}
        >

          <div>

            <div style={styles.kpiLabel}>
              Pending Tasks
            </div>

            <div style={styles.kpiValue}>
              {kpis.pendingTasks}
            </div>

          </div>

          <div style={styles.kpiIcon}>
            ⚠
          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* PROJECT / SITE CONTEXT */}
      {/* ================================================================ */}
      <div style={styles.contextCard}>

        <div style={styles.contextGrid}>


          {/* PROJECT */}
          <div style={styles.contextItem}>

            <div style={styles.contextLabel}>
              Project
            </div>

            <select
              value={projectId}
              onChange={(e) =>
                setProjectId(
                  e.target.value
                )
              }
              style={styles.contextSelect}
            >
              <option value="">
                Select Project
              </option>
              {
  projects.map((project) => (

    <option
      key={project.id}
      value={project.id}
    >

      {project.project_name}

    </option>
  ))
}
            </select>

          </div>


          {/* SITE STORE */}
          <div style={styles.contextItem}>

            <div style={styles.contextLabel}>
              Site Store
            </div>

            <div style={styles.storeBox}>

              {siteStoreName}

            </div>

          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* FILTERS */}
      {/* ================================================================ */}
      <div style={styles.filterCard}>


        {/* ROW 1 */}
        <div style={styles.filterRow}>


          {/* PHASE */}
          <div style={styles.filterGroup}>

            <label style={styles.label}>
              Phase / WBS
            </label>

            <select
              value={phaseId}
              onChange={(e) =>
                setPhaseId(e.target.value)
              }
              style={styles.select}
            >
              <option value="">
                Select Phase
              </option>
              {
  phases.map((phase) => (

    <option
      key={phase.id}
      value={phase.id}
    >

      {phase.name}

    </option>
  ))
}
            </select>

          </div>


          {/* TASK */}
          <div style={styles.filterGroup}>

            <label style={styles.label}>
              Task
            </label>

            <select
              value={taskId}
              onChange={(e) =>
                setTaskId(e.target.value)
              }
              style={styles.select}
            >
              <option value="">
                Select Task
              </option>
              {
  tasks.map((task) => (

    <option
      key={task.id}
      value={task.id}
    >

      {task.name}

    </option>
  ))
}
            </select>

          </div>

        </div>


        {/* ROW 2 */}
        <div style={styles.filterRow}>


          {/* STATUS */}
          <div style={styles.filterGroup}>

            <label style={styles.label}>
              Reservation Status
            </label>

            <select
              value={status}
              onChange={(e) =>
                setStatus(e.target.value)
              }
              style={styles.select}
            >
              <option value="ALL">
                All
              </option>

              <option value="PENDING">
                Pending
              </option>

              <option value="PARTIAL_RESERVED">
                Partial Reserved
              </option>

              <option value="RESERVED">
                Fully Reserved
              </option>

            </select>

          </div>


          {/* SEARCH */}
          <div
            style={{
              ...styles.filterGroup,
              flex: 1
            }}
          >

            <label style={styles.label}>
              Search Material
            </label>

            <div style={styles.searchBox}>

              <Search size={16} />

              <input
                type="text"
                placeholder={
                  "Search by material code or name"
                }
                value={searchText}
                onChange={(e) =>
                  setSearchText(
                    e.target.value
                  )
                }
                style={styles.searchInput}
              />

            </div>

          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* TASK SUMMARY */}
      {/* ================================================================ */}
      <div style={styles.summaryCard}>

        <div style={styles.summaryGrid}>


          <div>

            <div style={styles.summaryLabel}>
              Project
            </div>

            <div style={styles.summaryValue}>
            {summary.project_name}
          </div>

          </div>


          <div>

            <div style={styles.summaryLabel}>
              Phase
            </div>

            <div style={styles.summaryValue}>
              {summary.phase_name}
            </div>

          </div>


          <div>

            <div style={styles.summaryLabel}>
              Task
            </div>

            <div style={styles.summaryValue}>
              {summary.task_name}
            </div>

          </div>


          <div>

            <div style={styles.summaryLabel}>
              Status
            </div>

            <div style={{

                  ...styles.statusBadge,

                  background:
                    summary.status === "Reserved"
                      ? "#dcfce7"
                      : summary.status ===
                        "Partial Reserved"
                      ? "#fef3c7"
                      : "#e5e7eb",

                  color:
                    summary.status === "Reserved"
                      ? "#166534"
                      : summary.status ===
                        "Partial Reserved"
                      ? "#92400e"
                      : "#374151"
                }}>
              {summary.status}
            </div>

          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* GRID */}
      {/* ================================================================ */}
      <div style={styles.gridCard}>

        <table style={styles.table}>

          <thead>

            <tr>

              <th style={styles.th}>
                WBS
              </th>

              <th style={styles.th}>
                Task
              </th>

              <th style={styles.th}>
                Material Code
              </th>

              <th style={styles.th}>
                Material Name
              </th>

              <th style={styles.th}>
                Planned
              </th>

              <th style={styles.th}>
                Reserved
              </th>

              <th style={styles.th}>
                Balance
              </th>

              <th style={styles.th}>
                Stock
              </th>

              <th style={styles.th}>
                Status
              </th>

              <th style={styles.th}>
                Action
              </th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>

                <td
                  colSpan="10"
                  style={styles.emptyCell}
                >
                  Loading reservation data...
                </td>

              </tr>

            ) : error ? (

              <tr>

                <td
                  colSpan="10"
                  style={styles.errorCell}
                >
                  {error}
                </td>

              </tr>

            ) : rows.length === 0 ? (

              <tr>

                <td
                  colSpan="10"
                  style={styles.emptyCell}
                >
                  Please select project/task
                  to load materials
                </td>

              </tr>

            ) : (

              rows.map((row) => (

                <tr
                  key={
                    row.task_material_plan_id
                  }
                >

                  <td style={styles.td}>
                    {row.wbs_display || "-"}
                  </td>

                  <td style={styles.td}>
                    {row.task_name || "-"}
                  </td>

                  <td style={styles.td}>
                    {row.material_code}
                  </td>

                  <td style={styles.td}>
                    {row.material_name}
                  </td>

                  <td style={styles.td}>
                    {row.planned_qty}
                  </td>

                  <td style={styles.td}>
                    {row.reserved_qty}
                  </td>

                  <td style={styles.td}>
                    {row.balance_qty}
                  </td>

                  <td style={styles.td}>
                    {row.available_stock}
                  </td>

                  <td style={styles.td}>

                    <span
                      style={{

                        ...styles.gridStatusBadge,

                        background:
                          row.status === "Reserved"
                            ? "#dcfce7"
                            : row.status ===
                              "Partial Reserved"
                            ? "#fef3c7"
                            : "#e5e7eb",

                        color:
                          row.status === "Reserved"
                            ? "#166534"
                            : row.status ===
                              "Partial Reserved"
                            ? "#92400e"
                            : "#374151"
                      }}
                    >

                      {row.status}

                    </span>

                  </td>

                  <td style={styles.td}>

                    <button

                      style={styles.reserveBtn}

                      onClick={() =>
                        openReserveDrawer(row)
                      }
                    >
                      Reserve
                    </button>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

        <div style={styles.paginationBar}>

          <button style={styles.pageBtn}>
            {"< Prev"}
          </button>

          <div style={styles.pageText}>
            Page 1 / 20
          </div>

          <button style={styles.pageBtn}>
            {"Next >"}
          </button>

        </div>

      </div>

    
    
      {/* ============================================================ */}
      {/* RESERVATION DRAWER */}
      {/* ============================================================ */}
      {

        drawerOpen && (

          <>

            {/* OVERLAY */}
            <div
              style={styles.drawerOverlay}
              onClick={closeDrawer}
            />

            {/* DRAWER */}
            <div style={styles.drawer}>


              {/* HEADER */}
              <div style={styles.drawerHeader}>

                <div>

                  <div style={styles.drawerTitle}>
                    Reserve Material
                  </div>

                  <div style={styles.drawerSubtitle}>
                    Create reservation transaction
                  </div>

                </div>

                <button
                  style={styles.drawerCloseBtn}
                  onClick={closeDrawer}
                >
                  ✕
                </button>

              </div>


              {/* BODY */}
              <div style={styles.drawerBody}>


                {/* MATERIAL */}
                <div style={styles.drawerInfoCard}>

                  <div style={styles.drawerInfoRow}>
                    <span>Material</span>

                    <strong>
                      {
                        selectedRow?.material_name
                      }
                    </strong>
                  </div>

                  <div style={styles.drawerInfoRow}>
                    <span>Task</span>

                    <strong>
                      {
                        selectedRow?.task_name
                      }
                    </strong>
                  </div>

                  <div style={styles.drawerInfoRow}>
                    <span>Planned Qty</span>

                    <strong>
                      {
                        selectedRow?.planned_qty
                      }
                    </strong>
                  </div>

                  <div style={styles.drawerInfoRow}>
                    <span>Reserved Qty</span>

                    <strong>
                      {
                        selectedRow?.reserved_qty
                      }
                    </strong>
                  </div>

                  <div style={styles.drawerInfoRow}>
                    <span>Balance Qty</span>

                    <strong>
                      {
                        selectedRow?.balance_qty
                      }
                    </strong>
                  </div>

                </div>


                {/* QTY */}
                <div style={styles.drawerField}>

                  <label style={styles.drawerLabel}>
                    Reserve Qty
                  </label>

                  <input
                    type="number"
                    value={reserveQty}
                    onChange={(e) =>
                      setReserveQty(
                        e.target.value
                      )
                    }
                    style={styles.drawerInput}
                  />

                </div>


                {/* REMARKS */}
                <div style={styles.drawerField}>

                  <label style={styles.drawerLabel}>
                    Remarks
                  </label>

                  <textarea
                    value={remarks}
                    onChange={(e) =>
                      setRemarks(
                        e.target.value
                      )
                    }
                    style={styles.drawerTextarea}
                  />

                </div>


                {/* ERROR */}
                {
                  drawerError && (

                    <div style={styles.drawerError}>

                      {drawerError}

                    </div>
                  )
                }

              </div>


              {/* FOOTER */}
              <div style={styles.drawerFooter}>

                <button
                  style={styles.cancelBtn}
                  onClick={closeDrawer}
                >
                  Cancel
                </button>

                <button
                  style={styles.submitBtn}
                  onClick={submitReservation}
                  disabled={saving}
                >

                  {
                    saving
                      ? "Saving..."
                      : "Reserve Material"
                  }

                </button>

              </div>

            </div>

          </>
        )
     
     }
     </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  page: {
    padding: 20,
    background: "#f5f7fb",
    minHeight: "100vh"
  },


  // ===========================================================================
  // HEADER
  // ===========================================================================
  headerCard: {

    background:
      "linear-gradient(90deg, #2563eb, #3b82f6)",

    borderRadius: 14,

    padding: "18px 22px",

    marginBottom: 20,

    color: "#fff",

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center"
  },

  headerLeft: {

    display: "flex",

    alignItems: "center",

    gap: 14
  },

  headerIconWrap: {

    width: 48,

    height: 48,

    borderRadius: 12,

    background: "rgba(255,255,255,0.18)",

    display: "flex",

    alignItems: "center",

    justifyContent: "center"
  },

  headerTitle: {

    fontSize: 24,

    fontWeight: 700
  },

  headerSubtitle: {

    fontSize: 13,

    opacity: 0.92,

    marginTop: 4
  },

  headerActions: {

    display: "flex",

    gap: 10
  },

  refreshBtn: {

    display: "flex",

    alignItems: "center",

    gap: 8,

    background: "#fff",

    color: "#2563eb",

    border: "none",

    borderRadius: 8,

    padding: "10px 16px",

    fontWeight: 600,

    cursor: "pointer"
  },


  // ===========================================================================
  // KPI
  // ===========================================================================
  kpiGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",

    gap: 16,

    marginBottom: 20
  },

  kpiCard: {

    background: "#fff",

    borderRadius: 14,

    padding: 18,

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  kpiLabel: {

    fontSize: 13,

    color: "#6b7280",

    marginBottom: 8
  },

  kpiValue: {

    fontSize: 30,

    fontWeight: 700,

    color: "#111827"
  },

  kpiIcon: {

    fontSize: 26
  },


  // ===========================================================================
  // PROJECT CONTEXT
  // ===========================================================================
  contextCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 16,

    marginBottom: 20,

    boxShadow:
      "0 1px 3px rgba(0,0,0,0.08)"
  },

  contextGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(260px, 1fr))",

    gap: 16
  },

  contextItem: {

    display: "flex",

    flexDirection: "column"
  },

  contextLabel: {

    fontSize: 12,

    fontWeight: 700,

    color: "#6b7280",

    marginBottom: 6
  },

  contextSelect: {

    height: 40,

    borderRadius: 8,

    border: "1px solid #d1d5db",

    padding: "0 12px",

    background: "#fff"
  },

  storeBox: {

    height: 40,

    borderRadius: 8,

    border: "1px solid #e5e7eb",

    background: "#f9fafb",

    display: "flex",

    alignItems: "center",

    padding: "0 12px",

    fontWeight: 600,

    color: "#111827"
  },


  // ===========================================================================
  // FILTERS
  // ===========================================================================
  filterCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 16,

    marginBottom: 20,

    boxShadow:
      "0 1px 3px rgba(0,0,0,0.08)"
  },

  filterRow: {

    display: "flex",

    gap: 16,

    marginBottom: 16,

    flexWrap: "wrap"
  },

  filterGroup: {

    display: "flex",

    flexDirection: "column",

    minWidth: 220
  },

  label: {

    fontSize: 12,

    marginBottom: 6,

    color: "#374151",

    fontWeight: 600
  },

  select: {

    height: 38,

    borderRadius: 8,

    border: "1px solid #d1d5db",

    padding: "0 10px",

    background: "#fff"
  },

  searchBox: {

    display: "flex",

    alignItems: "center",

    gap: 8,

    border: "1px solid #d1d5db",

    borderRadius: 8,

    padding: "0 10px",

    height: 38,

    background: "#fff"
  },

  searchInput: {

    border: "none",

    outline: "none",

    width: "100%"
  },


  // ===========================================================================
  // TASK SUMMARY
  // ===========================================================================
  summaryCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 18,

    marginBottom: 20,

    boxShadow:
      "0 1px 3px rgba(0,0,0,0.08)"
  },

  summaryGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",

    gap: 16
  },

  summaryLabel: {

    fontSize: 12,

    fontWeight: 700,

    color: "#6b7280",

    marginBottom: 8
  },

  summaryValue: {

    fontSize: 15,

    fontWeight: 600,

    color: "#111827"
  },

  statusBadge: {

    display: "inline-flex",

    alignItems: "center",

    background: "#fef3c7",

    color: "#92400e",

    borderRadius: 30,

    padding: "6px 12px",

    fontSize: 12,

    fontWeight: 700
  },


  // ===========================================================================
  // GRID
  // ===========================================================================
  gridCard: {

    background: "#fff",

    borderRadius: 12,

    overflow: "hidden",

    boxShadow:
      "0 1px 3px rgba(0,0,0,0.08)"
  },

  table: {

    width: "100%",

    borderCollapse: "collapse"
  },

  th: {

    textAlign: "left",

    padding: 14,

    background: "#f3f4f6",

    fontSize: 13,

    fontWeight: 700,

    borderBottom: "1px solid #e5e7eb"
  },

  td: {

    padding: 14,

    borderBottom:
      "1px solid #f1f5f9",

    fontSize: 14
  },

  emptyCell: {

    padding: 40,

    textAlign: "center",

    color: "#9ca3af",

    fontSize: 14
  },

  errorCell: {

    padding: 40,

    textAlign: "center",

    color: "#dc2626",

    fontSize: 14
  },

  reserveBtn: {

    background: "#2563eb",

    color: "#fff",

    border: "none",

    borderRadius: 6,

    padding: "8px 14px",

    cursor: "pointer",

    fontWeight: 600
  },

  gridStatusBadge: {

    display: "inline-flex",

    alignItems: "center",

    background: "#e0f2fe",

    color: "#075985",

    borderRadius: 30,

    padding: "4px 10px",

    fontSize: 11,

    fontWeight: 700
  },


  // ===========================================================================
  // PAGINATION
  // ===========================================================================
  paginationBar: {

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    padding: 16,

    borderTop: "1px solid #e5e7eb"
  },

  pageBtn: {

    border: "1px solid #d1d5db",

    background: "#fff",

    borderRadius: 8,

    padding: "8px 14px",

    cursor: "pointer",

    fontWeight: 600
  },

  pageText: {

    fontSize: 14,

    fontWeight: 600,

    color: "#374151"
  },
  
drawerOverlay: {

  position: "fixed",

  top: 0,

  left: 0,

  right: 0,

  bottom: 0,

  background:
    "rgba(0,0,0,0.35)",

  zIndex: 1000
},

drawer: {

  position: "fixed",

  top: 0,

  right: 0,

  width: 460,

  height: "100vh",

  background: "#fff",

  zIndex: 1001,

  display: "flex",

  flexDirection: "column",

  boxShadow:
    "-4px 0 20px rgba(0,0,0,0.12)"
},

drawerHeader: {

  padding: 20,

  borderBottom:
    "1px solid #e5e7eb",

  display: "flex",

  justifyContent: "space-between",

  alignItems: "center"
},

drawerTitle: {

  fontSize: 20,

  fontWeight: 700
},

drawerSubtitle: {

  fontSize: 13,

  color: "#6b7280",

  marginTop: 4
},

drawerCloseBtn: {

  border: "none",

  background: "transparent",

  cursor: "pointer",

  fontSize: 20
},

drawerBody: {

  flex: 1,

  padding: 20,

  overflowY: "auto"
},

drawerInfoCard: {

  background: "#f9fafb",

  borderRadius: 10,

  padding: 16,

  marginBottom: 20
},

drawerInfoRow: {

  display: "flex",

  justifyContent: "space-between",

  marginBottom: 10,

  fontSize: 14
},

drawerField: {

  marginBottom: 20
},

drawerLabel: {

  display: "block",

  marginBottom: 8,

  fontSize: 13,

  fontWeight: 600
},

drawerInput: {

  width: "100%",

  height: 42,

  border:
    "1px solid #d1d5db",

  borderRadius: 8,

  padding: "0 12px"
},

drawerTextarea: {

  width: "100%",

  minHeight: 100,

  border:
    "1px solid #d1d5db",

  borderRadius: 8,

  padding: 12,

  resize: "vertical"
},

drawerError: {

  background: "#fee2e2",

  color: "#b91c1c",

  padding: 12,

  borderRadius: 8,

  fontSize: 13
},

drawerFooter: {

  padding: 20,

  borderTop:
    "1px solid #e5e7eb",

  display: "flex",

  justifyContent: "flex-end",

  gap: 12
},

cancelBtn: {

  border:
    "1px solid #d1d5db",

  background: "#fff",

  borderRadius: 8,

  padding: "10px 16px",

  cursor: "pointer"
},

submitBtn: {

  background: "#2563eb",

  color: "#fff",

  border: "none",

  borderRadius: 8,

  padding: "10px 18px",

  cursor: "pointer",

  fontWeight: 600
},
};